<template>
  <el-dialog title="审核终端" :visible.sync="visible" width="1000px" @close="handleClose">
    <!-- 基本信息 -->
    <el-card class="card-container">
      <span slot="header" class="card-header-title">基本信息</span>
      <el-descriptions :column="3" border size="small">
        <el-descriptions-item label="终端SN">{{
          formData.posSn
          }}</el-descriptions-item>
        <el-descriptions-item label="终端类型">{{  formData.amountType | formatAmountType(amountTypeOptions)  }}</el-descriptions-item>
        <el-descriptions-item label="是否激活">{{ formData.hasActivate === 1 ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="分公司">{{
          getGroupName(formData.groupId)
          }}</el-descriptions-item>
        <el-descriptions-item label="业务员">{{
          getSalesName(formData.salesId)
          }}</el-descriptions-item>
        <el-descriptions-item label="平台">{{
          formData.platfromName
          }}</el-descriptions-item>
        <el-descriptions-item label="入库时间">{{
          formData.storeTime
          }}</el-descriptions-item>
        <el-descriptions-item label="下拨时间">{{
          formData.allocateTime
          }}</el-descriptions-item>
        <el-descriptions-item label="回拨时间">{{
          formData.callbackTime
          }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 操作历史 -->
    <el-card class="card-container">
      <span slot="header" class="card-header-title">操作历史</span>
      <el-table :data="formData.transferRecordList" stripe border style="width: 100%">
        <el-table-column prop="transferType" label="操作类型" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.transferType === 0" class="tag-allocate">下拨</span>
            <span v-else-if="scope.row.transferType === 1" class="tag-callback">回拨</span>
          </template>
        </el-table-column>
        <el-table-column prop="oldGroupName" label="分公司" min-width="120" show-overflow-tooltip />
        <el-table-column prop="groupName" label="新分公司" min-width="120" show-overflow-tooltip />
        <el-table-column prop="oldSalesName" label="业务员" min-width="120" show-overflow-tooltip />
        <el-table-column prop="salesName" label="新业务员" min-width="120" show-overflow-tooltip />
        <el-table-column prop="allocateTime" label="下拨时间" min-width="160" show-overflow-tooltip />
        <el-table-column prop="callbackTime" label="回拨时间" min-width="160" show-overflow-tooltip />
      </el-table>
    </el-card>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button type="warning" @click="handleSubmit(2)" :loading="submitLoading">审核不通过</el-button>
      <el-button type="primary" @click="handleSubmit(1)" :loading="submitLoading">审核通过</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getTerminalDetail,
  auditTerminal,
  getGroupListToTerminal,
  getUserListByLogin,
} from "@/api/erp/terminal";

export default {
  name: "TerminalAuditDialog",
  data() {
    return {
      visible: false,
      submitLoading: false,
      editId: null,
      formData: {
        id: "",
        posSn: "",
        platfromName: "",
        brand: "",
        model: "",
        storeTime: "",
        allocateTime: "",
        callbackTime: "",
        hasActivate: "",
        groupId: "",
        salesId: "",
        amountType: "",
        transferRecordList: [],
      },
      groupList: [],
      salesList: [],
      amountTypeOptions: [
        { code: "299", desc: "299" },
        { code: "399", desc: "399" },
      ],
    };
  },
  filters: {
    formatAmountType(cellValue,amountTypeOptions) {
      return amountTypeOptions?.find(item => item.code === cellValue)?.desc || '-';
    }
  },
  methods: {
    open(id) {
      this.editId = id;
      this.visible = true;
      this.getGroupList();
      this.getUserList();
      this.getTerminalDetail();
    },
    // 获取分公司列表
    async getGroupList() {
      try {
        const { data } = await getGroupListToTerminal();
        this.groupList = data || [];
      } catch (error) {
        this.$message.error("获取分公司列表异常");
        this.groupList = [];
      }
    },
    // 获取业务员列表
    async getUserList() {
      try {
        const { data } = await getUserListByLogin();
        this.salesList = data || [];
      } catch (error) {
        this.$message.error("获取业务员列表异常");
        this.salesList = [];
      }
    },
    // 获取编辑数据
    async getTerminalDetail() {
      try {
        const { data } = await getTerminalDetail(this.editId);
        this.formData = data;
        if (Array.isArray(data.transferRecordList)) {
          this.formData.transferRecordList = data.transferRecordList;
        } else {
          this.formData.transferRecordList = [];
        }
      } catch (error) {
        this.$message.error("获取终端信息失败");
        this.handleClose();
      }
    },
    // 获取分公司名称
    getGroupName(groupId) {
      const group = this.groupList.find((item) => item.id === groupId);
      return group ? group.name : "-";
    },
    // 获取业务员名称
    getSalesName(salesId) {
      const sales = this.salesList.find((item) => item.id === salesId);
      return sales ? sales.name : "-";
    },
    // 提交编辑
    async handleSubmit(status) {
      if (this.submitLoading) {
        return;
      }

      this.submitLoading = true;
      try {
        await auditTerminal({
          ...this.formData,
          auditStatus: status,
        });
        this.$message.success("操作成功");
        this.$emit("success");
        this.handleClose();
      } catch (error) {
        this.$message.error("操作失败");
      } finally {
        this.submitLoading = false;
      }
    },
    // 关闭对话框
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style scoped lang="scss">
.card-container {
  margin-bottom: 20px;
}

.card-header-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.edit-select {
  width: 100%;
}

.tag-allocate {
  background-color: #67c23a;
  color: white;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}

.tag-callback {
  background-color: #f56c6c;
  color: white;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
